import { useEffect, useState } from "react";
import Lenis from "lenis";
import { gsap, ScrollTrigger, MOTION_OK } from "./gsap";
import { Nav } from "./components/Nav";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { Manifesto } from "./components/Manifesto";
import { Digital } from "./components/Digital";
import { Handcraft } from "./components/Handcraft";
import { Event } from "./components/Event";
import { Process } from "./components/Process";
import { Footer } from "./components/Footer";
import { Loader } from "./components/Loader";

// Visitors who ask for reduced motion skip the loader entirely.
const skipLoader = () => !window.matchMedia(MOTION_OK).matches;

export function App() {
  const [revealed, setRevealed] = useState(skipLoader);
  const [loading, setLoading] = useState(() => !skipLoader());

  useEffect(() => {
    document.fonts?.ready.then(() => ScrollTrigger.refresh());
  }, []);

  // The page stays put until the loader has left.
  useEffect(() => {
    document.documentElement.style.overflow = loading ? "hidden" : "";
    if (loading || !window.matchMedia(MOTION_OK).matches) return;

    const lenis = new Lenis({ anchors: true });
    lenis.on("scroll", ScrollTrigger.update);
    const raf = (time: number) => lenis.raf(time * 1000);
    gsap.ticker.add(raf);
    gsap.ticker.lagSmoothing(0);

    return () => {
      gsap.ticker.remove(raf);
      lenis.destroy();
    };
  }, [loading]);

  return (
    <>
      <div aria-hidden className="grain pointer-events-none fixed inset-0 z-[60] opacity-[0.07]" />
      {loading && <Loader onReveal={() => setRevealed(true)} onDone={() => setLoading(false)} />}
      <Nav />
      <main className="w-full max-w-full overflow-x-clip">
        <Hero ready={revealed} />
        <Event />
        <Manifesto />
        <Digital />
        <Marquee />
        <Handcraft />
        <Process />
      </main>
      <Footer />
    </>
  );
}

export default App;
